module.exports = __webpack_public_path__ + "img/list-none.1b377c85.svg";